import Vue from 'vue'
import VueRouter, { Route, RouteConfig } from 'vue-router'
import ViewpointApp from "@/views/ViewpointApp.vue";
import ViewpointAppEmbed from "@/views/ViewpointAppEmbed.vue";
import ViewpointAppEmbed2 from "@/views/ViewpointAppEmbed2.vue";
import ViewpointAppShare from "@/views/ViewpointAppShare.vue";
import SignUp from "@/views/Auth/SignUp.vue";
import Login from "@/views/Auth/Login.vue";
import Verify from "@/views/Auth/Verify.vue";
import ResetPassword from "@/views/Auth/ResetPassword.vue";
import ChangePassword from "@/views/Auth/ChangePassword.vue";
import { Urls } from "@/Urls";
import PricingPlans from "@/views/Memberships/PricingPlans.vue";
import Checkout from "@/views/Checkout/Checkout.vue";
import Account from "@/views/Account/Account.vue";
import UserProfile from "@/components/account/UserProfile.vue";
import UserMembership from "@/components/account/UserMembership.vue";
import { getModule } from "vuex-module-decorators";
import Users from "@/store/modules/Users";
import ChoiceFactorRanker from "@/views/Ranker/FactorChoiceViewpointRanker.vue";
import ChoiceScorer from "@/views/ChoiceViewpointsScorer/ChoiceViewpointsScorer.vue";
import Results from "@/views/ChoiceViewpointsScorer/Results.vue";
import ChoiceComparisonScoring from "@/views/ViewpointChoicesScorer/ViewpointChoicesScorer.vue";
import ChoiceSubmitter from "@/views/ChoiceSubmitter/ChoiceSubmitter.vue";
import ViewpointWeighting from "@/views/Viewpoint/Weighting/ViewpointWeighting.vue";
import DecisionFileImport from "@/views/DecisionImport/DecisionFileImporter.vue";
import Navigation from "@/store/modules/Navigation";
import ModelBuilder from "@/views/ModelBuilder/ModelBuilder.vue";
import JoinDecision from "@/views/Account/JoinDecision.vue";
import ChoiceForm from "@/views/ChoiceForm.vue";
import ListManager from "@/views/Lists/ListManager.vue";
import ScoreInput from "@/views/ChoiceScoreInputForm/ScoreInput.vue";
import ChoiceCard from '@/views/ChoiceCards/ChoiceCard.vue';
import CardDesignMainPage from '@/components/apps/CardDesignMainPage.vue';
import ManageUsers from '@/views/Users/ManageUsers.vue';
import Marketplace from '@/views/Marketplace/MarketplaceHome.vue';
import ViewpointManager from '@/views/Viewpoint/ViewpointManager.vue';
import ChoiceManager from '@/views/ChoiceManager/ChoiceManager.vue';
import ExternalDecisionClone from "@/views/ExternalDecisionClone.vue";
import AppletsGallery from "@/components/apps/AppletGallery.vue";
import AccessRestriction from "@/views/Auth/AccessRestriction.vue";
import DecisionManager from "@/components/decisions/DecisionManager.vue";
import MembersManager from "@/views/Users/MembersManager.vue";
import Insights from "@/views/Insights/Insights.vue";
import ExternalLogin from "@/views/Auth/ExternalLogin.vue";
import vuetify from '@/plugins/vuetify';

Vue.use(VueRouter);
const routes: RouteConfig[] = [
    {
        name: "Signup",
        path: Urls.SIGNUP,
        component: SignUp,
        meta: {requiresUnAuth: true},
        props: (route: any) => ({error: route.query.error_description})
    },
    {
        name: 'Login',
        path: Urls.LOGIN,
        component: Login,
        meta: {requiresUnAuth: true},
        props: (route: any) => ({
            error: route.query.error_description,
            queryDecisionId: route.query.decisionId,
            queryPasscode: route.query.passcode
        })
    },
    {
        name: 'ExternalLogin',
        path: Urls.REDIRECT_TO_LOGIN,
        component: ExternalLogin,
    },
    {
        name: 'VerifyAccount',
        path: Urls.VERIFY_ACCOUNT,
        component: Verify,
        meta: {requiresUnAuth: true},
        props: (route: any) => ({username: route.query.username, confirmationCode: route.query.confirmationCode})
    },
    {
        name: 'ResetPassword',
        path: Urls.RESET_PASSWORD,
        component: ResetPassword
    },
    {
        name: 'ChangePassword',
        path: Urls.CHANGE_PASSWORD,
        component: ChangePassword,
        meta: {requiresUnAuth: true},
        props: (route: any) => ({username: route.query.username, confirmationCode: route.query.confirmationCode})
    },
    {
        name: 'JoinDecision',
        path: Urls.JOIN_DECISION,
        component: JoinDecision,
        meta: {requiresAuth: true},
        props: (route: any) => ({decisionId: route.query.decisionId, passcode: route.query.passcode})
    },
    {
        name: 'PricingPlans',
        path: Urls.PRICING_PLANS,
        component: PricingPlans,
        props: (route: any) => ({coupon: route.query.coupon})
    },
    {
        name: 'Checkout',
        path: Urls.CHECKOUT,
        component: Checkout,
        meta: {requiresAuth: true},
        props: (route: Route) => ({
            products: Array.isArray(route.query.product) ? route.query.product : [route.query.product],
            coupon: route.query.coupon,
            successUrl: route.query.successUrl,
            fromUrl: route.query.cancelUrl
        })
    },
    {
        name: 'Account',
        path: Urls.ACCOUNT,
        component: Account,
        meta: {requiresAuth: true},
        props: true,
        children: [
            {
                name: 'AccountProfile',
                path: 'profile',
                component: UserProfile
            },
            {
                name: 'AccountMembership',
                path: 'membership',
                component: UserMembership
            }
        ]
    },
    {
        path: Urls.ACCOUNT,
        redirect: {name: 'AccountProfile'}
    },
    {
        name: 'Members',
        path: Urls.MEMBERSHIP,
        component: MembersManager,
        props: (route: Route) => ({
            queryDecisionId: route.query.decisionId
        })
    },
    {
        name: 'CloneDecision',
        path: Urls.CLONING_DECISION,
        component: ExternalDecisionClone,
        meta: {requiresAuth: true},
        props: (route: any) => ({
            decisionId: route.query['decision-id'], 
            includeChoices: (route.query['include-choices'] === 'true'),
            includeViewpoints: (route.query['include-viewpoints'] === 'true'),
            includeApps: (route.query['include-apps'] === 'true'),
            includeLists: (route.query['include-lists'] === 'true'),
            includeComments: (route.query['include-comments'] === 'true'),
            includeUsers: (route.query['include-user'] === 'true')
        })
    },
    {
        name: 'Marketplace',
        path: Urls.MARKETPLACE,
        component: Marketplace,
        props: (route:any) => ({
            isMarketplace: true
        })
    },
    {
        name: 'App',
        path: Urls.APP,
        component: ViewpointApp,
        meta: {requiresAuth: (process.env.USER_BRANCH !== 'test'), requiresPlan: false},
        props: (route: any) => ({
            queryViewpointIds: route.query.viewpointIds,
            queryActiveViewpointId: route.query.activeViewpointId,
            queryDecisionId: route.query.decisionId,
            queryChoiceId: route.query.choiceId,
            queryActiveFactorId: route.query.activeFactorId,
            queryShowNonContributing: route.query.showNonContributing,
            queryVisibleChoices: route.query.visibleChoices,
            queryChoiceListIds: route.query.choiceListIds,
            queryFactorListIds: route.query.factorListIds,
            queryViewpointListIds: route.query.viewpointListIds,
            queryShowDesc: route.query.showDesc,
            queryShowBars: route.query.showBars,
            queryShowIconScoring: route.query.showIconScoring,
            querySkipGroups: route.query.skipGroups,
            queryShowNonListFactors: route.query.showNonListFactors,
            queryViewpointSort: route.query.viewpointSort,
            queryChoiceSort: route.query.choiceSort,
            queryOpenLeft: route.query.openLeft,
            queryOpenRight: route.query.openRight,
            queryChoiceColumnWidth: route.query.choiceColumnWidth,
            queryViewpointColumnWidth: route.query.viewpointColumnWidth,
            queryChoiceNumOfCols: route.query.choiceNumOfCols,
            queryTrimTopGroups: route.query.trimTopGroups,
            queryShowScores: route.query.showScores,
            queryShowKeys: route.query.showKeys,
            queryShowComments: route.query.showComments,
            queryChoiceFirstCol: route.query.choiceFirstCol,
            queryShowCustomRange: route.query.showCustomRange,
            queryViewpointFirstCol: route.query.viewpointFirstCol,
            queryRankChoiceCol: route.query.rankChoiceCol,
            queryPinnedRight: route.query.pinnedRight,
            queryPinnedLeft: route.query.pinnedLeft,
            queryCommentVertical: route.query.commentVertical,
            queryAllowGenerateViewpoints: route.query.allowGenerateViewpoints,
            querySelectionMenu: route.query.selectionMenu,
            queryViewpointSelectionMenu: route.query.viewpointSelectionMenu,
            queryChoiceSelectionMenu: route.query.choiceSelectionMenu,
            queryFactorSelectionMenu: route.query.factorSelectionMenu,
            queryMbDraggable: route.query.mbDraggable,
            queryDenomScoring: route.query.denomScoring,
            queryStandardize: route.query.standardize,
            queryCreateChoice: route.query.createChoice,
            queryEditModel: route.query.editModel,
            queryEditContent: route.query.editContent,
            queryEditWeights: route.query.editWeights,
            queryEditSumRule: route.query.editSumRule,
            queryEditScoringRule: route.query.editScoringRule,
            queryEditScores: route.query.editScores,
            queryEditComments: route.query.editComments,
            queryShowFactorData: route.query.showFactorData
        }),
        children: [
            {
                name: 'ClassifyRankChoice',
                path: Urls.CHOICE_SCORER_BINS,
                component: ChoiceFactorRanker
            },
            {
                name: 'ScoreChoice',
                path: Urls.CHOICE_SCORER,
                component: ChoiceScorer,
                props: {
                    viewpointVisibility: true
                }
            },
            {
                name: 'Results',
                path: Urls.RESULTS,
                component: Results
            },
            {
                name: 'ScoreChoices',
                path: Urls.CHOICE_SCORER_COMPARE,
                component: ChoiceComparisonScoring
            },
            {
                name: 'ChoiceSubmitter',
                path: Urls.CHOICE_SUBMITTER,
                component: ChoiceSubmitter
            },
            {
                name: 'ChoiceCard',
                path: Urls.CHOICE_CARDS,
                component: ChoiceCard
            },
            {
                name: 'Viewpoint',
                path: Urls.WEIGHTING,
                component: ViewpointWeighting
            },
            {
                name: 'DecisionBuilder',
                path: Urls.TEMPLATE_BUILDER,
                component: ModelBuilder
            },
            {
                name: 'DecisionFileImporter',
                path: Urls.DECISION_UPLOAD,
                component: DecisionFileImport
            },
            {
                name: 'ListManager',
                path: Urls.LIST_MANAGER,
                component: ListManager
            },
            {
                name: 'CardDesignMainPage',
                path: Urls.APP_LIBRARY,
                component: CardDesignMainPage
            },
            {
                name: 'ManageUsers',
                path: Urls.USERS,
                component: ManageUsers
            },
            {
                name: 'Templates',
                path: Urls.TEMPLATES,
                component: Marketplace,
                props: true
            },
            {
                name: 'ViewpointManager',
                path: Urls.VIEWPOINT_MANAGER,
                component: ViewpointManager,
            },
            {
                name: 'ChoiceManager',
                path: Urls.CHOICE_MANAGER,
                component: ChoiceManager,
            },
            {
                name: 'DecisionManager',
                path: Urls.DECISION_MANAGER,
                component: DecisionManager,
            },
            {
                name: 'Insights',
                path: Urls.INSIGHTS,
                component: Insights,
            }
        ]
    },
    {
        name: 'AppShare',
        path: Urls.APP_SHARE,
        component: ViewpointAppShare,
        meta: {requiresAuth: false, requiresPlan: false},
        props: (route: any) => ({
            queryAppEmbedId: route.query.appEmbedId,
            queryAppEmbedMenuId: route.query.appEmbedMenuId,
            queryViewpointIds: route.query.viewpointIds,
            queryActiveViewpointId: route.query.activeViewpointId,
            queryActiveFactorId: route.query.activeFactorId,
            querySkipGroups: route.query.skipGroups,
            queryDecisionId: route.query.decisionId,
            queryChoiceId: route.query.choiceId,
            queryShowNonContributing: route.query.showNonContributing,
            queryVisibleChoices: route.query.visibleChoices,
            queryFactorListIds: route.query.factorListIds,
            queryViewpointListIds: route.query.viewpointListIds,
            queryChoiceListIds: route.query.choiceListIds,
            queryShowNonListFactors: route.query.showNonListFactors,
            queryViewpointSort: route.query.viewpointSort,
            queryChoiceSort: route.query.choiceSort,
            queryOpenLeft: route.query.openLeft,
            queryOpenRight: route.query.openRight,
            queryShowIconScoring: route.query.showIconScoring,
            queryAutocomplete: route.query.autocomplete,
            queryChoiceColumnWidth: route.query.choiceColumnWidth,
            queryViewpointColumnWidth: route.query.viewpointColumnWidth,
            queryChoiceNumOfCols: route.query.choiceNumOfCols,
            queryEnd: route.query.requiredEnd,
            queryTrimTopGroups: route.query.trimTopGroups,
            queryShowScores: route.query.showScores,
            queryShowKeys: route.query.showKeys,
            queryShowBars: route.query.showBars,
            queryShowComments: route.query.showComments,
            queryChoiceFirstCol: route.query.choiceFirstCol,
            queryShowCustomRange: route.query.showCustomRange,
            queryViewpointFirstCol: route.query.viewpointFirstCol,
            queryRankChoiceCol: route.query.rankChoiceCol,
            queryAuthFlow: route.query.authFlow,
            queryShowDesc: route.query.showDesc,
            queryPinnedRight: route.query.pinnedRight,
            queryPromote: route.query.promote,
            queryPinnedLeft: route.query.pinnedLeft,
            queryTemplate: route.query.template,
            queryAllowGenerateViewpoints: route.query.allowGenerateViewpoints,
            queryMbDraggable: route.query.mbDraggable,
            queryCreateChoice: route.query.createChoice,
            queryDenomScoring: route.query.denomScoring,
            queryStandardize: route.query.standardize,
            queryChartTop: route.query.chartTop,
        })
    },
    {
        name: 'AppBuild',
        path: Urls.APP_BUILD,
        component: ViewpointAppEmbed,
        meta: {requiresAuth: (process.env.USER_BRANCH !== 'test'), requiresPlan: false},
        props: (route: any) => ({
            queryAppEmbedId: route.query.appEmbedId,
            queryAppEmbedMenuId: route.query.appEmbedMenuId,
            queryViewpointIds: route.query.viewpointIds,
            queryActiveViewpointId: route.query.activeViewpointId,
            queryDecisionId: route.query.decisionId,
            queryChoiceId: route.query.choiceId,
            queryActiveFactorId: route.query.activeFactorId,
            queryShowNonContributing: route.query.showNonContributing,
            queryVisibleChoices: route.query.visibleChoices,
            queryChoiceListIds: route.query.choiceListIds,
            queryFactorListIds: route.query.factorListIds,
            queryViewpointListIds: route.query.viewpointListIds,
            queryShowDesc: route.query.showDesc,
            queryShowBars: route.query.showBars,
            queryShowIconScoring: route.query.showIconScoring,
            querySkipGroups: route.query.skipGroups,
            queryShowNonListFactors: route.query.showNonListFactors,
            queryViewpointSort: route.query.viewpointSort,
            queryChoiceSort: route.query.choiceSort,
            queryOpenLeft: route.query.openLeft,
            queryOpenRight: route.query.openRight,
            queryAutocomplete: route.query.autocomplete,
            queryChoiceColumnWidth: route.query.choiceColumnWidth,
            queryViewpointColumnWidth: route.query.viewpointColumnWidth,
            queryChoiceNumOfCols: route.query.choiceNumOfCols,
            queryEnd: route.query.requiredEnd,
            queryTrimTopGroups: route.query.trimTopGroups,
            queryShowScores: route.query.showScores,
            queryShowKeys: route.query.showKeys,
            queryShowComments: route.query.showComments,
            queryChoiceFirstCol: route.query.choiceFirstCol,
            queryShowCustomRange: route.query.showCustomRange,
            queryViewpointFirstCol: route.query.viewpointFirstCol,
            queryRankChoiceCol: route.query.rankChoiceCol,
            queryPromote: route.query.promote,
            queryMbDraggable: route.query.mbDraggable
        }),
            children: [
            {
                name: 'ClassifyRankChoiceEmbed',
                path: Urls.CHOICE_SCORER_BINS_EMBED,
                component: ChoiceFactorRanker
            },
            {
                name: 'ScoreChoiceEmbed',
                path: Urls.CHOICE_SCORER_EMBED,
                component: ChoiceScorer,
                props: {
                    viewpointVisibility: true
                }
            },
            {
                name: 'ScoreChoicesEmbed',
                path: Urls.CHOICE_SCORER_COMPARE_EMBED,
                component: ChoiceComparisonScoring
            },
            {
                name: 'ChoiceSubmitterEmbed',
                path: Urls.CHOICE_SUBMITTER_EMBED,
                component: ChoiceSubmitter
            },
            {
                name: 'ChoiceCardEmbed',
                path: Urls.CHOICE_CARDS_EMBED,
                component: ChoiceCard
            },
            {
                name: 'ViewpointEmbed',
                path: Urls.WEIGHTING_EMBED,
                component: ViewpointWeighting
            },
            {
                name: 'DecisionBuilderEmbed',
                path: Urls.TEMPLATE_BUILDER_EMBED,
                component: ModelBuilder
            },
            {
                name: 'ListManagerEmbed',
                path: Urls.LIST_MANAGER_EMBED,
                component: ListManager
            },
            {
                name: 'ResultsEmbed',
                path: Urls.RESULTS_EMBED,
                component: Results
            },
        ]
    },
    {
        name: 'AppEmbed',
        path: Urls.APP_EMBED,
        component: ViewpointAppEmbed2,
        meta: {requiresAuth: false, requiresPlan: false},
        props: (route: any) => ({
            queryAppEmbedId: route.query.appEmbedId,
            queryAppEmbedMenuId: route.query.appEmbedMenuId,
            queryViewpointIds: route.query.viewpointIds,
            queryActiveViewpointId: route.query.activeViewpointId,
            queryDecisionId: route.query.decisionId,
            queryChoiceId: route.query.choiceId,
            queryActiveFactorId: route.query.activeFactorId,
            queryShowNonContributing: route.query.showNonContributing,
            queryVisibleChoices: route.query.visibleChoices,
            queryChoiceListIds: route.query.choiceListIds,
            queryFactorListIds: route.query.factorListIds,
            queryViewpointListIds: route.query.viewpointListIds,
            queryShowDesc: route.query.showDesc,
            queryShowBars: route.query.showBars,
            queryShowIconScoring: route.query.showIconScoring,
            querySkipGroups: route.query.skipGroups,
            queryShowNonListFactors: route.query.showNonListFactors,
            queryViewpointSort: route.query.viewpointSort,
            queryChoiceSort: route.query.choiceSort,
            queryOpenLeft: route.query.openLeft,
            queryOpenRight: route.query.openRight,
            queryAutocomplete: route.query.autocomplete,
            queryChoiceColumnWidth: route.query.choiceColumnWidth,
            queryViewpointColumnWidth: route.query.viewpointColumnWidth,
            queryChoiceNumOfCols: route.query.choiceNumOfCols,
            queryEnd: route.query.requiredEnd,
            queryTrimTopGroups: route.query.trimTopGroups,
            queryShowScores: route.query.showScores,
            queryShowKeys: route.query.showKeys,
            queryShowComments: route.query.showComments,
            queryChoiceFirstCol: route.query.choiceFirstCol,
            queryShowCustomRange: route.query.showCustomRange,
            queryViewpointFirstCol: route.query.viewpointFirstCol,
            queryRankChoiceCol: route.query.rankChoiceCol,
            queryPinnedRight: route.query.pinnedRight,
            queryPinnedLeft: route.query.pinnedLeft,
            queryHomepage: route.query.homepage,
            queryAllowGenerateViewpoints: route.query.allowGenerateViewpoints,
            querySelectionMenu: route.query.selectionMenu,
            queryViewpointSelectionMenu: route.query.viewpointSelectionMenu,
            queryChoiceSelectionMenu: route.query.choiceSelectionMenu,
            queryFactorSelectionMenu: route.query.factorSelectionMenu,
            queryAutocreate: route.query.autocreate,
            queryTemplateViewpoint: route.query.templateViewpoint,
            queryIncludeWeights: route.query.includeWeights,
            queryIncludeKeys: route.query.includeKeys,
            queryIncludeScores: route.query.includeScores,
            queryMbDraggable: route.query.mbDraggable,
            queryDenomScoring: route.query.denomScoring,
            queryStandardize: route.query.standardize,
            queryCreateChoice: route.query.createChoice,
            queryBlockPinLeft: route.query.blockPinLeft,
            queryEditModel: route.query.editModel,
            queryEditContent: route.query.editContent,
            queryEditWeights: route.query.editWeights,
            queryEditSumRule: route.query.editSumRule,
            queryEditScoringRule: route.query.editScoringRule,
            queryEditScores: route.query.editScores,
            queryEditComments: route.query.editComments,
            queryVpTime: route.query.vptime,
            queryBrandingPrimary: route.query.brandingPrimary,
            queryChartTop: route.query.chartTop,
            queryLockState: route.query.lockState,
        }),
            children: [
            {
                name: 'ClassifyRankChoiceEmbed2',
                path: Urls.CHOICE_SCORER_BINS_EMBED2,
                component: ChoiceFactorRanker
            },
            {
                name: 'ScoreChoiceEmbed2',
                path: Urls.CHOICE_SCORER_EMBED2,
                component: ChoiceScorer,
                props: {
                    viewpointVisibility: true
                }
            },
            {
                name: 'ScoreChoicesEmbed2',
                path: Urls.CHOICE_SCORER_COMPARE_EMBED2,
                component: ChoiceComparisonScoring
            },
            {
                name: 'ChoiceSubmitterEmbed2',
                path: Urls.CHOICE_SUBMITTER_EMBED2,
                component: ChoiceSubmitter
            },
            {
                name: 'ChoiceCardEmbed2',
                path: Urls.CHOICE_CARDS_EMBED2,
                component: ChoiceCard
            },
            {
                name: 'ViewpointEmbed2',
                path: Urls.WEIGHTING_EMBED2,
                component: ViewpointWeighting
            },
            {
                name: 'DecisionBuilderEmbed2',
                path: Urls.TEMPLATE_BUILDER_EMBED2,
                component: ModelBuilder
            },
            {
                name: 'ListManagerEmbed2',
                path: Urls.LIST_MANAGER_EMBED2,
                component: ListManager
            },
            {
                name: 'ResultsEmbed2',
                path: Urls.RESULTS_EMBED2,
                component: Results
            },
            {
                name: 'ManageUsersEmbed2',
                path: Urls.USERS_MANAGER_EMBED2,
                component: ManageUsers
            },
            {
                name: 'ViewpointManager',
                path: Urls.VIEWPOINT_MANAGER_EMBED2,
                component: ViewpointManager,
            },
            {
                name: 'ChoiceManager',
                path: Urls.CHOICE_MANAGER_EMBED2,
                component: ChoiceManager,
            },
            {
                name: 'AppletsGallery',
                path: Urls.GALLERY_EMBED2,
                component: AppletsGallery,
                props: (route: any) => ({
                    embedApplet: true
                }),

            },
            {
                name: 'AccessRestriction',
                path: Urls.ACCESS_RESTRICTED_EMBED2,
                component: AccessRestriction,
            }
        ]
    },
    {
        name: 'ChoiceInputForm',
        path: '/input/choice',
        component: ChoiceForm,
        props: (route: any) => ({
            formId: route.query.form,
            templateId: route.query.templateId,
            choiceId: route.query.choiceId,
            viewpointId: route.query.viewpointId,
            platform: route.query.platform,
            shareCode: route.query.shareCode
        }),
    },
    {
        name: 'ChoiceScoreInputForm',
        path: '/input/choice/score',
        component: ScoreInput,
        meta: {requiresAuth: true},
        props: (route: any) => ({
            formId: route.query.form
        }),
    },
    {
        path: '*', redirect: '/'
    }
]


const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

const usersModule = getModule(Users);
const navigationModule = getModule(Navigation);
router.beforeResolve(async (to, from, next) => {
    if ( !to.fullPath.includes(Urls.APP_EMBED) ) {
        vuetify.framework.theme.themes.light = {...vuetify.userPreset.theme.themes.light};
    }

    if (to.matched.some(record => record.meta.requiresAuth || record.meta.requiresUnAuth)) {
        if (to.query.code) {
            await new Promise(resolve => setTimeout(resolve, 1000));
        }

        usersModule.getCurrentAuthUser()
            .then((data: any) => {
                if (to.matched.some(record => record.meta.requiresPlan)) {
                    usersModule.getCurrentUserMembership()
                        .then(membership => {
                            if (membership && membership.subscriptionId) {
                                next();
                            } else {
                                window.location.href = Urls.REDIRECT_TO_LOGIN;
                            }
                        })
                        .catch(err => {
                            window.location.href = Urls.REDIRECT_TO_LOGIN;
                        })

                } else if (to.matched.some(record => record.meta.requiresAuth)) {
                    next();
                } else {
                    next({
                        path: Urls.APP
                    });
                }
            })
            .catch((e: any) => {
                console.log(e)
                if (to.matched.some(record => record.meta.requiresAuth)) {
                    navigationModule.changeRedirectAfterAuthPath(to.fullPath)
                    // check if link isn't /clone 
                    if (to.matched.some(record => record.name !== 'CloneDecision') && !to.path.includes('decision/join')) {
                        window.location.href = Urls.REDIRECT_TO_LOGIN;
                    }                   
                } else {
                    next();
                }
            });
    }
    next();
})


export default router;
